module.exports = __webpack_public_path__ + "static/AWS-68bb490a9d1313e1f14fc5dfbf55769c.jpg";